import type { FC } from "react";
import cn from "classnames";
import styles from "@/layout/agentChat/agentChatDrawer.module.scss";
import type { AgentHistoryEntry } from "@/context/agent/types.ts";

type RequestViewProps = {
  entry: AgentHistoryEntry;
}

const RequestView: FC<RequestViewProps> = ({ entry }) => {

  if (!entry.query) {
    return null;
  }

  return (
    <div className={cn(styles.messageRow, styles.requestRow)}>
      <div className={cn(styles.messageBubble, styles.requestBubble)}>
        <div className={styles.messageText}>{entry.query}</div>
      </div>
    </div>
  );
};

export default RequestView;
